














































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Search from '@/app/ui/components/Search/index'
import ModalDeleteAll from '@/app/ui/components/ModalDeleteAll/index.vue'
import { NotificationModule } from '@/app/store/modules/notifications'
import { AdminCMSModule } from '@/app/store/modules/adminCMS'
import ModalAdd from './ModalAdd.vue'

import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
@Component({
  components: {
    search: Search,
    'modal-delete-all': ModalDeleteAll,
    'modal-add': ModalAdd,
  },
})
export default class extends Vue {
  @Prop({}) public selected
  @Prop({}) public funcSearch
  @Prop({}) public isDisabled
  @Prop({}) public clearRowSelected

  public created() {
    this.getAdminRole()
  }

  public randomWord: string = ''
  public randomCode() {
    const word = 'ABCDEFGHIJKLMNOPQRSTUVWXTZ'
    const max = 3
    let random = ''
    for (let i = 0; i < max; i++) {
      const hasil = Math.floor(Math.random() * word.length)
      random += word.substring(hasil, hasil + 1)
    }
    return (this.randomWord = random)
  }

  public text = ''

  public resetText() {
    this.text = ''
    this.funcSearch()
  }

  public $v: Vuelidate
  @Validate({
    required,
    minLength: minLength(4),
    maxLength: maxLength(255),
  })
  public description = ''
  public resetAdd() {
    this.$v.description.$reset()
    this.description = ''
  }

  public modalDelete = {
    id: 'modal-deletes',
  }
  public funcDelete(item, index, button) {
    this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
  }
  // delete data
  public funcOke(item, index, button) {
    const ids = this.selected.map((i) => i.id)
    AdminCMSModule.deleteUser({ ids })
    this.$root.$emit('bv::hide::modal', this.modalDelete.id, button)
    this.clearRowSelected()
  }
  public addUserAdmin() {
    this.$root.$emit('bv::show::modal', 'modal-add-user')
  }

  public getAdminRole() {
    AdminCMSModule.getListRole()
  }
}
